<template>
    <div>
        <b-form-file
            :placeholder="placeHolderText || 'Select or Drop File Here...'"
            :drop-placeholder="dropPlaceHolderText || 'Drop file here...'"
            @change="loadTextFromFile"
        ></b-form-file>
    </div>
</template>

<script>
import Papa from 'papaparse'
export default {
    data() {
        return {
            formattedData: [],
        }
    },
    props: [
        'startRowNo',
        'columnsMap',
        'placeHolderText',
        'dropPlaceHolderText',
    ],
    methods: {
        loadTextFromFile(ev) {
            console.log('ev.target', ev.target)
            console.log('ev.target.files', ev.target.files)
            if (!ev.target.files) return
            const file = ev.target.files[0]
            const reader = new FileReader()
            //  const _this = this

            reader.onload = e => {
                const csv = e.target.result
                const { data, errors, meta } = Papa.parse(csv)
                const columnsMap = { ...this.columnsMap }
                console.log('errors', errors)
                console.log('meta', meta)

                const startRowNo = parseInt(this.startRowNo, 10) || 0
                const keys = Object.keys(columnsMap)
                console.log('keys', keys)

                const getFieldNames = columnNo => {
                    return keys.filter(key => columnsMap[key] === columnNo)
                }

                this.formattedData = data
                    .slice(startRowNo - 1)
                    .reduce((_output, columns) => {
                        const record = {}
                        let valid = false
                        for (let i = 0; i < columns.length; i++) {
                            if (columns[i].length) {
                                for (let fieldname of getFieldNames(i)) {
                                    record[fieldname] = columns[i]
                                    valid = true
                                }
                            }
                        }
                        if (valid) _output.push(record)
                        return _output
                    }, [])
                this.$emit('input', this.formattedData)
            }
            reader.readAsText(file)
        },
    },
}
</script>